// Full-document render of the embeddable nav-only fragment (NavIFrameView).
// PageSkeleton renders the site header but omits the footer and the <main>
// wrapper, and suppresses the OneTrust consent furniture -- matching the legacy
// nav-iframe.html which blanked {% block footer %}, {% block main %}, and
// {% block onetrust %}. The iframe-resizer config + contentWindow scripts are
// appended as children (where the blanked <main> used to be).
import React from "react";

import { Context, templates } from "@reactivated";

import { useSSRNonce } from "@thelabnyc/thelabui/src/hooks/useSSRNonce";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.NavIFrameDocumentTemplate,
): React.JSX.Element => {
    const staticBase = React.useContext(Context).chrome.static_base;
    const nonce = useSSRNonce();
    return (
        <PageSkeleton
            pageChrome={props.page_chrome}
            footer={false}
            wrapMain={false}
            showOneTrust={false}
        >
            {/* iFrameResizer config must be set before the contentWindow script
                loads. The legacy nav-iframe used heightCalculationMethod "max". */}
            <script
                nonce={nonce}
                dangerouslySetInnerHTML={{
                    __html: `window.iFrameResizer = { heightCalculationMethod: "max" };`,
                }}
            />
            <script
                src={`${staticBase}dist2/iframe-resizer/iframeResizer.contentWindow.js`}
                nonce={nonce}
                suppressHydrationWarning={true}
            />
        </PageSkeleton>
    );
};
